export default __webpack_public_path__ + "static/media/Eljan Simuratli.16004540.pdf";